<template>
  <v-dialog v-model="isShowDialog" :persistent="persistent" :width="width" :scrollable="scrollable">
    <v-card :min-width="width">
      <v-card-title
        class="bg-color-gray py-0"
        :style="{
          height: headerHeight + 'px',
          width: '100%',
          zIndex: 20
        }"
      >
        <v-layout row style="margin-left: 25px">
          <slot name="dialog-title" />
        </v-layout>
        <v-icon
          :size="25"
          :style="{
            right: 0 + 'px',
            top: headerHeight / 4 + 'px',
            right: headerHeight / 4 + 'px',
            zIndex: 21
          }"
          @click="close"
          >close</v-icon
        >
      </v-card-title>

      <v-layout column align-space-around class="scroll-y" :class="centered ? 'pa-4' : 'pa-0'">
        <slot name="dialog-content" />

        <slot name="dialog-action" />
      </v-layout>

      <v-layout column align-space-around>
        <slot name="dialog-fix-action" />
      </v-layout>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'Dialog',
  model: { prop: 'isShow', event: 'input' },
  props: {
    isShow: { type: Boolean, required: true },
    persistent: { type: Boolean, required: false, default: false },
    clearable: { type: Boolean, required: false, default: true },
    width: { type: [String, Number], required: false, default: 924 },
    height: { type: [String, Number], required: false, default: 300 },
    centered: { type: Boolean, required: false, default: true },
    isCloseConfirm: { type: Boolean, required: false, default: false },
    scrollable: { type: Boolean, required: false, default: false }
  },
  computed: {
    isShowDialog: {
      get() {
        return this.isShow;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    close() {
      this.isCloseConfirm ? this.$emit('close') : (this.isShowDialog = !this.isShowDialog);
    }
  },
  data() {
    return {
      headerHeight: 50
    };
  }
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/_atoms/Dialog.vue